import React, { createContext, useState } from 'react';

import GroupAddData from './GroupAddData';

export const GroupAddStateContext = createContext();

const GroupAddContextProvider = ({ children }) => {
  const stateHook = useState(GroupAddData.INITIAL_STATE);

  return (
    <GroupAddStateContext.Provider value={stateHook}>
      {children}
    </GroupAddStateContext.Provider>
  );
};

export default GroupAddContextProvider;